// src/components/Admin/AdminCategories.js
"use client";

import { useEffect, useState, useContext } from "react";
import { Table, Button, Spinner } from "react-bootstrap";
import api from "../../services/api";
import { toast } from "react-toastify";
import WalletChargeModal from "./WalletChargeModal";
import CreditAddModal from "./CreditAddModal";
import CategoryFormModal from "./CategoryFormModal";
import ZeroOutBalanceModal from "./ZeroOutBalanceModal";
import { handleApiSuccess, handleApiError } from "../../services/errorHandler"
import { AuthContext } from "../../context/AuthContext";

const AdminCategoriesComp = () => {
  const { user, role } = useContext(AuthContext);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showChargeModal, setShowChargeModal] = useState(false);
  const [showCreditModal, setShowCreditModal] = useState(false);

  const [showZeroOutModal, setShowZeroOutModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    targetType: 'CATEGORY',
    userId: null,
    categoryId: null,
    merchantCategoryId: null,
  });
  const handleOpenModal = (config) => {
    setModalConfig(config);
    setShowZeroOutModal(true);
  };
  const handleSuccess = () => {
    console.log('Zero out operation successful!');
    // در اینجا می‌توانید لیست‌ها را رفرش کنید یا کاری دیگر انجام دهید
  };

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const [showFormModal, setShowFormModal] = useState(false);
  const [editCategory, setEditCategory] = useState(null);

  const fetchCategories = async () => {
    try {
      const { data } = await api.get("/admin/categories");
      setCategories(data);
    } catch (err) {
      toast.error("خطا در دریافت دسته‌ها");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const deleteCategory = async (id) => {
    if (!window.confirm("آیا مطمئن هستید که می‌خواهید دسته را حذف کنید؟")) return;

    try {
      await api.delete(`/admin/categories/${id}`);
      toast.success("دسته حذف شد");
      fetchCategories();
    } catch (err) {
      toast.error("خطا در حذف دسته");
    }
  };

  // ریست پسورد کاربران گروه
  const resetGroupUsersPassword = async (id) => {
    if (!window.confirm("آیا از ریست پسورد کاربر اطمینان دارید؟ رمز به ۴ رقم آخر کد ملی تغییر خواهد کرد؟")) return;

    try {
      const res = await api.patch(`/admin/categories/${id}/reset-password`);
      console.log(res);
      handleApiSuccess(res, 'عملیات با موفقیت انجام شد');
      //fetchUsers();
    } catch (err) {
      handleApiError(err, "خطا در ثبت درخواست");
    }
  };

  if (loading) return <Spinner animation="border" className="d-block m-auto mt-5" />;

  return (
    <>
      <div className="mb-3 d-flex gap-2">
        <Button
          variant="primary"
          onClick={() => {
            setEditCategory(null);
            setShowFormModal(true);
          }}
        >
          افزودن دسته جدید
        </Button>

        {(user.mobile === '09132085327' || 1) && (
          <>
            <Button
              size="sm"
              variant="light"
              onClick={() => handleOpenModal({ targetType: 'GENERAL_WALLET' })}
              className="pb-0 d-flex"
            >
              <i className="material-symbols-outlined">backspace</i> <span className="pt-1 ps-1">حذف بالانس همه</span>
            </Button>
          </>
        )}
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>نام دسته</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((c, idx) => (
            <tr key={c.id}>
              <td>{idx + 1}</td>
              <td>{c.name}</td>
              <td className="d-flex gap-2 flex-wrap">
                <Button
                  size="sm"
                  variant="success"
                  onClick={() => {
                    setSelectedCategoryId(c.id);
                    setShowChargeModal(true);
                  }}
                >
                  شارژ کیف پول
                </Button>

                {/* ✅ دکمه جدید برای اعتبار */}
                <Button
                  size="sm"
                  variant="info"
                  onClick={() => {
                    setSelectedCategoryId(c.id);
                    setShowCreditModal(true);
                  }}
                >
                  تغییر اعتبار
                </Button>

                <Button
                  size="sm"
                  variant="warning"
                  onClick={() => {
                    setEditCategory(c);
                    setShowFormModal(true);
                  }}
                >
                  ویرایش
                </Button>

                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => deleteCategory(c.id)}
                >
                  حذف
                </Button>

                {user.mobile === '09132085327' && (
                  <>
                    <Button
                      size="sm"
                      variant="secondary"
                      onClick={() => resetGroupUsersPassword(c.id)}
                      className="pb-0"
                    >
                      <i className="material-symbols-outlined">key</i>
                    </Button>
                  </>
                )}

                {(user.mobile === '09132085327' || 1) && (
                  <>
                    <Button
                      size="sm"
                      variant="light"
                      onClick={() => handleOpenModal({ targetType: 'CATEGORY', categoryId: c.id })}
                      className="pb-0 d-flex"
                    >
                      <i className="material-symbols-outlined">backspace</i> <span className="pt-1 ps-1">حذف بالانس</span>
                    </Button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* مودال فرم دسته */}
      <CategoryFormModal
        show={showFormModal}
        onHide={() => setShowFormModal(false)}
        category={editCategory}
        onSuccess={fetchCategories}
      />

      {/* مودال شارژ کیف پول */}
      <WalletChargeModal
        show={showChargeModal}
        onHide={() => setShowChargeModal(false)}
        targetType="CATEGORY"
        targetId={selectedCategoryId}
        onSuccess={fetchCategories}
      />

      {/* ✅ مودال تغییر اعتبار */}
      <CreditAddModal
        show={showCreditModal}
        onHide={() => setShowCreditModal(false)}
        targetType="CATEGORY"
        targetId={selectedCategoryId}
        onSuccess={fetchCategories}
      />

      {/* مودال حذف بالانس */}
      <ZeroOutBalanceModal
        show={showZeroOutModal}
        onHide={() => setShowZeroOutModal(false)}
        onSuccess={handleSuccess}
        userId={modalConfig.userId}
        categoryId={modalConfig.categoryId}
        merchantCategoryId={modalConfig.merchantCategoryId}
        targetType={modalConfig.targetType}
      />
    </>
  );
};

export default AdminCategoriesComp;
